import AnimationKeyframe from './_animation-keyframe.js'

export default {
  name: 'AnimationKeyframes',
  values: {
    from: {
      configSet: AnimationKeyframe,
      configValues: {},
    },
    to: {
      configSet: AnimationKeyframe,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
